








































































































import { Component, Vue } from 'vue-property-decorator';
import {
  IAwsMachine
} from "@/api/types";
import { getAwsMachines } from "@/api/cyberlab";
import { EventBus } from "@/utils/eventBus";
import Pagination from "@/components/Pagination/index.vue";

@Component({
  name: 'AwsMachines',
  components: {Pagination}
})
export default class extends Vue {
  private tableKey = 0;
  private subnets: string[] = [];
  private awsMachines: IAwsMachine[] = [];
  private selectedSubnet: string = '';
  private filteredAwsMachines: IAwsMachine[] = [];
  private paginatedAwsMachines: IAwsMachine[] = [];
  private listLoading = true;
  private total = 0;
  private searchTerm: string = '';
  private cloneDialogVisible: boolean = false;
  private currentPage: number = 1;
  private perPage: number = 20;

  created() {
    this.getSubnets();
    this.getAwsMachines()
    EventBus.$on("aws-machines-search", this.filterBySearch);
  }

  destroyed() {
    EventBus.$off("aws-machines-search", this.filterBySearch);
  }

  private async getSubnets() {
    this.subnets = [...new Set(this.awsMachines.map(m => m.subnetName))]
    this.subnets.sort((a, b) => (a > b) ? 1 : -1);
  }

  private filterBySearch(data: any) {
    this.searchTerm = data.value;
    this.filteredAwsMachines = this.filterBySearchTerm(this.awsMachines);
    if (this.selectedSubnet) {
      this.filteredAwsMachines = this.filteredAwsMachines.filter(m => m.subnetName === this.selectedSubnet);
    }
    this.paginatedAwsMachines = this.paginateData(this.filteredAwsMachines);
  }

  private filterBySearchTerm(awsMachines: IAwsMachine[]) {
    let targetString: string = "";
    if (this.searchTerm != "") {
      return awsMachines.filter((am: IAwsMachine) => {
        if (am.name) {
          targetString = `${am.name}${am.privateIpAddress}${am.status}`
          return targetString.toLowerCase().includes(this.searchTerm.toLowerCase())
        }
        return false;
      });
    }
    return awsMachines;
  }

  private paginateData(cohortLabs: IAwsMachine[]) {
    let start = (this.currentPage - 1) * this.perPage;
    let end = this.currentPage * this.perPage;
    return cohortLabs.slice(start, end);
  }

  private async getAwsMachines() {
    this.listLoading = true;
    await getAwsMachines({}).then(
      (response: any) => {
        let data = response.data;
        this.awsMachines = data;
        this.total = data.length;
        this.filterBySearch({value: ''});
        this.listLoading = false;
        this.getSubnets();
      },
      (error: any) => {
        console.log(error);
        this.listLoading = false;
      }
    );
  }

  private reloadAwsMachines() {
    this.getAwsMachines()
  }

  private handleSubnetSelection() {
    if (this.selectedSubnet) {
      this.filteredAwsMachines = this.awsMachines.filter(m => m.subnetName === this.selectedSubnet);
    } else {
      this.filteredAwsMachines = this.awsMachines
    }
    this.paginatedAwsMachines = this.paginateData(this.filteredAwsMachines);
  }

  private paginationChange(data: any) {
    this.currentPage = data.page;
    if (this.perPage !== data.limit) {
      this.currentPage = 1;
      this.perPage = data.limit;
    }
    this.filterBySearch({value: this.searchTerm});
  }
}
